import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Location, AsyncPipe } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { Title } from '@angular/platform-browser';
import { Observable, of, Subject, takeUntil } from 'rxjs';
import { User } from '../../users/user.model';
import { MatMiniFabButton } from '@angular/material/button';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import {
  faArrowLeft,
  faArrowRightFromBracket,
  faBars,
  faCircleQuestion,
  faLock,
  faUser,
} from '@fortawesome/pro-light-svg-icons';

@Component({

    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    standalone: true,
    imports: [
        MatMiniFabButton,
        MatMenu,
        MatMenuItem,
        MatMenuTrigger,
        RouterLink,
        AsyncPipe,
        FaIconComponent,
    ],
})
export class NavbarComponent implements OnInit, OnDestroy {
  public location: Location;
  public mobile_menu_visible = 0;
  private _toggleButton?: Element;
  private _sidebarVisible: boolean;
  private _layer?: HTMLElement;
  public isLoggedIn: Observable<boolean> = of(false);
  public authUser: Observable<User | undefined>;
  private _subject = new Subject<void>();
  protected readonly icons = {
    menu: faBars,
    back: faArrowLeft,
    person: faUser,
    help: faCircleQuestion,
    lock: faLock,
    logout: faArrowRightFromBracket,
  } as const;

  constructor(
    location: Location,
    private element: ElementRef,
    private router: Router,
    private authService: AuthService,
    public titleService: Title
  ) {
    this.location = location;
    this._sidebarVisible = false;
    this.isLoggedIn = this.authService.loggedIn;
    this.authUser = this.authService.user;
  }

  ngOnInit() {
    const navbar: HTMLElement = this.element.nativeElement;
    this._toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
    this.router.events.pipe(takeUntil(this._subject)).subscribe(() => {
      this.sidebarClose();
      this._layer = document.getElementsByClassName(
        'close-layer'
      )[0] as HTMLElement;
      if (this._layer) {
        this._layer.remove();
        this.mobile_menu_visible = 0;
      }
    });
  }

  sidebarOpen() {
    const toggleButton = this._toggleButton;
    const body = document.getElementsByTagName('body')[0];
    setTimeout(function () {
      toggleButton?.classList.add('toggled');
    }, 500);

    body.classList.add('nav-open');

    this._sidebarVisible = true;
  }

  sidebarClose() {
    const body = document.getElementsByTagName('body')[0];
    this._toggleButton?.classList.remove('toggled');
    this._sidebarVisible = false;
    body.classList.remove('nav-open');
  }

  sidebarToggle() {
    // const toggleButton = this.toggleButton;
    // const body = document.getElementsByTagName('body')[0];
    const toggle = document.getElementsByClassName('navbar-toggler')[0];

    if (this._sidebarVisible === false) {
      this.sidebarOpen();
    } else {
      this.sidebarClose();
    }
    const body = document.getElementsByTagName('body')[0];

    if (this.mobile_menu_visible === 1) {
      // $('html').removeClass('nav-open');
      body.classList.remove('nav-open');
      if (this._layer) {
        this._layer.remove();
      }
      setTimeout(function () {
        toggle.classList.remove('toggled');
      }, 400);

      this.mobile_menu_visible = 0;
    } else {
      setTimeout(function () {
        toggle.classList.add('toggled');
      }, 430);

      this._layer = document.createElement('div');
      this._layer.setAttribute('class', 'close-layer');

      if (body.querySelectorAll('.main-panel')) {
        document
          .getElementsByClassName('main-panel')[0]
          .appendChild(this._layer);
      } else if (body.classList.contains('off-canvas-sidebar')) {
        document
          .getElementsByClassName('wrapper-full-page')[0]
          .appendChild(this._layer);
      }

      setTimeout(() => {
        this._layer?.classList.add('visible');
      }, 100);

      this._layer.onclick = () => {
        // asign a function
        body.classList.remove('nav-open');
        this.mobile_menu_visible = 0;
        this._layer?.classList.remove('visible');
        setTimeout(() => {
          this._layer?.remove();
          toggle.classList.remove('toggled');
        }, 400);
      };

      body.classList.add('nav-open');
      this.mobile_menu_visible = 1;
    }
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }
  ngOnDestroy(): void {
    this._subject.next();
    this._subject.complete();
  }
}
